import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=574d62cb&scoped=true&"
import script from "./Page4.vue?vue&type=script&lang=js&"
export * from "./Page4.vue?vue&type=script&lang=js&"
import style0 from "./Page4.vue?vue&type=style&index=0&id=574d62cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574d62cb",
  null
  
)

export default component.exports